import React from "react";
import { Modal as UILibModal } from "@bca/ui-library";
import { ModalProps as UILibModalProps } from "@bca/ui-library/dist/Modal/modal.type";

interface ModalProps extends UILibModalProps {
  fullScreen?: boolean;
}

const Modal: React.FunctionComponent<ModalProps> = ({
  css,
  fullScreen,
  ...props
}) => {
  const internalCss = fullScreen
    ? {
        ...css,
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        transform: "none",
        borderRadius: 0,
      }
    : css;

  return <UILibModal css={internalCss} {...props} />;
};

export default Modal;
